module.exports = __webpack_public_path__ + "static/whitebooties-26a16efb3c76ec41f09921ff6135e264.jpeg";